export const benchmarkingEndpoints = {
  getAnalysis: (reportId, type) =>
    `/benchmarking/${reportId}${type ? `?type=${encodeURIComponent(type)}` : ""}`,
};
